<template>
  <p>0.2.0-Thu Mar 03 2022 15:48:09 GMT+0530 (India Standard Time)</p>
</template>

<script>
export default {
  name: "Version"
}
</script>

<style scoped>

</style>
